export enum LANGUAGE_CODE {
  GERMAN = "de",
  ENGLISH = "en",
  POLISH = "pl",
  SWISS = "ch",
  AUSTRIAN = "at",
  ZULU = "zu",
  ENGLISH_GB = "en-GB",
  ENGLISH_US = "en-US",
  CZECH = "cs-CZ",
  SLOVAK = "sk-SK",
}
